interface Props {
  items: { q: string; a: string }[];
}

export default function FAQSection({ items }: Props) {
  if (items.length === 0) return null;
  return (
    <section className="mt-12">
      <h2 className="font-serif text-xl" style={{ marginTop: 0 }}>
        Common questions
      </h2>
      <dl className="mt-4 space-y-6">
        {items.map((f, i) => (
          <div key={i}>
            <dt className="faq-question speakable font-serif text-base font-semibold text-foreground">
              {f.q}
            </dt>
            <dd
              className="faq-answer speakable mt-1 text-[15px] leading-relaxed"
              style={{ color: "hsl(var(--foreground))" }}
            >
              {f.a}
            </dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
